import axios from 'axios'
import router from '../router'

export default ({
    namespaced: true,
    state: {
        cart: null,
        cartLoading: false,
        cartActionLoading: false,
    },
    
    getters:{
        cart(state){
            return state.cart
        },
        cartLoading(state){
            return state.cartLoading
        },
        cartActionLoading(state){
            return state.cartActionLoading
        },
    },

    mutations: {
        SET_CART(state, data) {
            state.cart = data
        },
        SET_CART_LOADING(state, data) {
            state.cartLoading = data
        },
        SET_CART_ACTION_LOADING(state, data) {
            state.cartActionLoading = data
        },
    },

    actions: {
        async getCart({commit, dispatch}) {
            commit('SET_CART_LOADING', true)
            await axios.get(`cart`)
                .then(response => {
                    commit('SET_CART', response.data)
                    return response.data
                })
                .catch(error => {
                    dispatch('auth/setAuthErrors', error.response.data, { root: true })
                    return false;
                })
                .finally(() => commit('SET_CART_LOADING', false))
        },
        async addToCart({dispatch}, data) {
            let item = { 'modelo': '', 'cantidad': 1, 'action': 'add'}
            if( typeof(data.modelo) == 'undefined' ) {
                dispatch('auth/setAuthErrors', "Error al intentar agregar el producto", {root: true } )
            }
            item.codigo = data.modelo
            if( typeof(data.cantidad) != 'undefined' ) {
                item.cantidad = data.cantidad
            }
            dispatch('updateCart', item)
        },        
        async updateCart({commit, dispatch}, data) {
            commit('SET_CART_ACTION_LOADING', true)
            await axios.post(`cart/update`, data)
                .then(response => {
                    commit('SET_CART', response.data)
                    dispatch('auth/setAuthMessage', "Carrito actualizado correctamente", {root: true } )
                    return response.data.message
                })
                .catch(error => {
                    dispatch('auth/setAuthErrors', error.response.data, { root: true })
                    return false;
                })
                .finally(() => commit('SET_CART_ACTION_LOADING', false))
        },
        async setPrepaid({commit, dispatch}, status) {
            commit('SET_CART_ACTION_LOADING', true)
            await axios.put(`/cart/prepaid/${status}`)
                .then(response => {
                    commit('SET_CART', response.data)
                    dispatch('auth/setAuthMessage', "Carrito actualizado correctamente", {root: true } )
                    return response.data.message
                })
                .catch(error => {
                    dispatch('auth/setAuthErrors', error.response.data, { root: true })
                    return false;
                })
                .finally(() => commit('SET_CART_ACTION_LOADING', false))                
        },
        async setPayment({commit, dispatch}, codigo) {
            commit('SET_CART_ACTION_LOADING', true)            
            await axios.put(`/cart/payment/${codigo}`)
                .then(response => {
                    commit('SET_CART', response.data)
                    dispatch('auth/setAuthMessage', "Carrito actualizado correctamente", {root: true } )
                    return response.data.message
                })
                .catch(error => {
                    dispatch('auth/setAuthErrors', error.response.data, { root: true })
                    return false;
                })
                .finally(() => commit('SET_CART_ACTION_LOADING', false))
        },
        async setObservation({commit, dispatch}, text) {
            commit('SET_CART_ACTION_LOADING', true)            
            await axios.patch(`/cart/observation`, {
                observacion: text
            })
                .then(response => {
                    commit('SET_CART', response.data)
                    return response.data.message
                })
                .catch(error => {
                    dispatch('auth/setAuthErrors', error.response.data, { root: true })
                    return false;
                })
                .finally(() => commit('SET_CART_ACTION_LOADING', false))
        },
        async deleteItemFromCart({commit, dispatch}, id) {
            commit('SET_CART_ACTION_LOADING', true)            
            await await axios.put(`/cart/remove/${id}`)
                .then(response => {
                    commit('SET_CART', response.data)
                    dispatch('auth/setAuthMessage', "Carrito actualizado correctamente", {root: true } )
                    return response.data.message
                })
                .catch(error => {
                    dispatch('auth/setAuthErrors', error.response.data, { root: true })
                    return false;
                })
                .finally(() => commit('SET_CART_ACTION_LOADING', false))                
        },
        async deleteCart({commit, dispatch}) {
            commit('SET_CART_LOADING', true)
            await axios.delete(`/cart`)
                .then(response => {
                    commit('SET_CART', response.data)
                    dispatch('auth/setAuthMessage', "Carrito eliminado correctamente", {root: true } )                    
                    return response.data.message
                })
                .catch(error => {
                    dispatch('auth/setAuthErrors', error.response.data, { root: true })
                    return false;
                })
                .finally(() => commit('SET_CART_LOADING', false))
        },
        async confirmCart({commit, dispatch}) {
            commit('SET_CART_LOADING', true)
            await axios.get(`/cart/confirm`)
                .then(response => {
                    dispatch('auth/setAuthMessage', "Carrito finalizado correctamente", {root: true } )
                    router.replace({
                        name: 'cart.checkout'
                    })
                    setTimeout(() => 
                        commit('SET_CART', response.data),
                    3000); 
                })
                .catch(error => {
                    dispatch('auth/setAuthErrors', error.response.data, { root: true })
                    return false;
                })
                .finally(() => commit('SET_CART_LOADING', false))
        },
    }
})
